import { QuestTaskChoosePlayerName } from "./qeustTaskChoosePlayerName/QuestTaskChoosePlayerName";
import { QuestTaskCollectResource } from "./questCollectResource/QuestTaskCollectResource";
import { QuestTaskBuyImprovement } from "./questTaskBuyImprovement/QuestTaskBuyImprovement";
import { QuestTaskEarnResource } from "./questTaskEarnResource/QuestTaskEarnResource";
import { QuestTaskFulfillContract } from "./questTaskFulfillContract/QuestTaskFulfillContract";
import { QuestTaskHaveBuilding } from "./questTaskHaveBuilding/QuestTaskHaveBuilding";
import { QuestTaskHaveExpansion } from "./questTaskHaveExpansion/QuestTaskHaveExpansion";
import { QuestTaskHaveHappiness } from "./questTaskHaveHappiness/QuestTaskHaveHappiness";
import { QuestTaskInviteFriends } from "./QuestTaskInviteFriends";
import { QuestTaskJoinAlliance } from "./questTaskJoinAlliance/QuestTaskJoinAlliance";
import { QuestTaskMakePayment } from "./QuestTaskMakePayment";
import { QuestTaskReachPlayerLevel } from "./questTaskReachPlayerLevel/QuestTaskReachPlayerLevel";
import { QuestTaskSpendResource } from "./questTaskSpendResource/QuestTaskSpendResource";
import { QuestTaskStartProduction } from "./questTaskStartProduction/QuestTaskStartProduction";
import { QuestTaskUseHumus } from "./questTaskUseHumus/QuestTaskUseHumus";
import { QuestTaskUseOutskirt } from "./questTaskUseOutskirt/QuestTaskUseOutskirt";
import { TypeQuestTask } from "./TypeQuestTask";
export var questTaskComponentMap = new Map()
    .set(TypeQuestTask.ChoosePlayerName, QuestTaskChoosePlayerName)
    .set(TypeQuestTask.CollectResource, QuestTaskCollectResource)
    .set(TypeQuestTask.EarnResource, QuestTaskEarnResource)
    .set(TypeQuestTask.FulfillContract, QuestTaskFulfillContract)
    .set(TypeQuestTask.HaveBuilding, QuestTaskHaveBuilding)
    .set(TypeQuestTask.HaveExpansion, QuestTaskHaveExpansion)
    .set(TypeQuestTask.HaveHappiness, QuestTaskHaveHappiness)
    .set(TypeQuestTask.JoinCoop, QuestTaskJoinAlliance)
    .set(TypeQuestTask.ReachPlayerLevel, QuestTaskReachPlayerLevel)
    .set(TypeQuestTask.SpendResource, QuestTaskSpendResource)
    .set(TypeQuestTask.StartProduction, QuestTaskStartProduction)
    .set(TypeQuestTask.UseHumus, QuestTaskUseHumus)
    .set(TypeQuestTask.MakePayment, QuestTaskMakePayment)
    .set(TypeQuestTask.BuyImprovement, QuestTaskBuyImprovement)
    .set(TypeQuestTask.UseOutskirt, QuestTaskUseOutskirt)
    .set(TypeQuestTask.InviteFriends, QuestTaskInviteFriends)
    .set(TypeQuestTask.UseCookingStation, undefined)
    .set(TypeQuestTask.UsePackage, undefined);



//////////////////
// WEBPACK FOOTER
// ./src/features/info/quest/list/tasks/questTaskComponentMap.ts
// module id = 2665
// module chunks = 3